module.exports = __webpack_public_path__ + "img/logo.63f713e9.png";